import Progress from 'dashboard/templates/views/Patient/Progress/Progress';

import status from './status';
import goalSetting from './goal-setting/index.js';

/**
 * Journey progress routes
 * @name router.Journey-progress
 */

const navigationSteps = {
  nextDiscussionStep: {
    PatientRecordProgressStatus: 'PatientRecordProgressGoalSetting',
  },
  prevDiscussionStep: {
    PatientRecordProgressGoalSetting: 'PatientRecordProgressStatus',
  }
}

export default {
  path: 'progress',
  component: Progress,
  name: 'PatientRecordProgress',
  props: navigationSteps,
  redirect: { name: 'PatientRecordProgressStatus' },
  meta: {
    // title: 'Patient Record - Progress',
    title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')}`,
    loggedInOnly: true,
  },
  children: [
    status,
    goalSetting,
  ],
};
